import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const getGrantDashboard = async () => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/dashboard/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)

        return response
    }
    catch (error) {
        console.error('Erro ao buscar a dashboard: ', error)
        return {}
    }
}

const getGrantDashboardCalendar = async (grantId, payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/dashboard/${grantId}/calendario/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        },
        params: payload
    }

    try {
        const response = await axios.get(requestURL, config)

        return response
    }
    catch (error) {
        console.error('Erro ao buscar o calendário da outorga: ', error)
        return {}
    }
}

const getGrantDashboardFullCharts = async (grantId, payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/dashboard/${grantId}/graficos/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.post(requestURL, payload, config)

        return response
    }
    catch (error) {
        console.error('Erro ao buscar os gráficos completos da outorga: ', error)
        return {}
    }
}

export {
    getGrantDashboard,
    getGrantDashboardCalendar,
    getGrantDashboardFullCharts,
}
